<template>
  <div class="row elevation-3">
    <div class="col-10 mx-auto text-center">
      <carousel v-bind="carouselOptions" v-if="boxes.length">
        <slide v-for="(box, i) in boxes" :key="i">
          <CarouselBox :box="box" @filter="filter" />
        </slide>
      </carousel>
      <Spinner v-else />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Carousel, Slide } from "vue-carousel";
import Spinner from "@/components/Spinner";
import CarouselBox from "@/components/CarouselBox";

export default {
  name: "CarouselContainer",
  components: {
    Carousel,
    Slide,
    CarouselBox,
    Spinner,
  },
  data() {
    return {
      carouselOptions: {
        navigationEnabled: true,
        "mouse-drag": false,
        paginationEnabled: false,
        perPageCustom: [
          [100, 1],
          [600, 2],
          [1234, 3],
          [1500, 4],
        ],
      },
      boxes: [],
    };
  },
  computed: {
    ...mapState(["dataUrl"]),
  },
  methods: {
    filter(category) {
      this.$emit("filter", category);
    },
    async getCategories() {
      let apiUrl = `${this.dataUrl}/mdTemaCategory/getAllCategories`;

      try {
        let { data } = await this.axios.get(apiUrl);
        let boxes = [];
        let box = [];

        for (let i of data.content) {
          box.push(i);

          if (box.length == 2) {
            boxes.push(box);
            box = [];
          }
        }

        this.boxes = boxes;
      } catch {
        // this.getCategories();
      }
    },
  },
  mounted() {
    this.getCategories();
  },
};
</script>
